export default "__VITE_ASSET__abbbec35__"